<div id="blurb_wrapper" class="blurb__wrapper">
	<section id="blurb" class="component component--blurb blurb bg-color-blue text-color-dark" [ngStyle]="{'background-color': blurbTabContent.tab_blurb_block_color}">
		<div class="wrapper">
			<div class="row">
				<div *ngFor="let blurb of blurbTabContent.inner_blurb" class="blurb-col col-sm-6 col-md-4">
					<div class="blurb_div" *ngIf="'' != blurb.blurb_title || '' != blurb.blurb_description || '' != blurb.blurb_image">
						<a *ngIf="blurb.blurb_link_type == 'internal' && blurb.blurb_internal_link.url != ''" routerLink="/{{ blurb.blurb_internal_link.url }}" target="{{ blurb.blurb_internal_link.target }}">
							<div class="blurb_image" *ngIf="blurb.blurb_image != ''">
								<img src="{{ blurb.blurb_image }}" alt="">
							</div>
							<div class="blurb_content">
								<h3 *ngIf="'' != blurb.blurb_title" [innerHtml]="blurb.blurb_title"></h3>
								<p *ngIf="'' != blurb.blurb_description" [innerHtml]="blurb.blurb_description"></p>
							</div>
						</a>
						<a *ngIf="blurb.blurb_link_type == 'external' && blurb.blurb_external_link != ''" href="{{ blurb.blurb_external_link }}" target="_blank">
							<div class="blurb_image" *ngIf="blurb.blurb_image != ''">
								<img src="{{ blurb.blurb_image }}" alt="">
							</div>
							<div class="blurb_content">
								<h3 *ngIf="'' != blurb.blurb_title" [innerHtml]="blurb.blurb_title"></h3>
								<p *ngIf="'' != blurb.blurb_description" [innerHtml]="blurb.blurb_description"></p>
							</div>
						</a>
					</div>
				</div>
			</div>
		</div>
	</section>
</div>